import VProgressCircular from './VProgressCircular'

export { VProgressCircular }
export default VProgressCircular
